import React, { useEffect, useRef, useState } from "react";
import { FaTrashAlt } from "react-icons/fa";
import WarningPopup from "./WarningPopup";
import { HiFilter } from "react-icons/hi";
import Pagination from "Components/Pagination/Pagination";
import { usePermission } from "Context/PermissionContext";

const DeleteReqList = ({
  accDelReq,
  userDataLoading,
  currentPage,
  totalPages,
  itemsPerPage,
  selectedFilter,
  onPageChange,
}) => {
  const dropdownRef = useRef(null);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [warnPopupOpen, setWarnPopupOpen] = useState(false);
  const [usersData, setUsersData] = useState({});
  const { permissions } = usePermission();
  const currentTabPermissions =
    permissions?.userRequests?.subModule?.accDeleteReq?.permissions;

  const handleOpen = (user) => {
    setUsersData(user);
    setWarnPopupOpen(true);
  };
  const handleClose = () => setWarnPopupOpen(false);
  const toggleDropdown = () => setIsDropdownOpen(!isDropdownOpen);

  const handleOptionClick = (option) => {
    setIsDropdownOpen(false);
    onPageChange(1, option);
  };

  const handleClickOutside = (event) => {
    if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
      setIsDropdownOpen(false);
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  return (
    <>
      <WarningPopup
        avatarUrl={usersData?.selected_Avatar?.avatarUrl}
        username={usersData?.fullName}
        warnPopupOpen={warnPopupOpen}
        handleClose={handleClose}
        fetchUsers={onPageChange}
        userId={usersData?._id}
      />

      <div className="py-5">
        <div className="flex flex-col items-center justify-between space-y-4 rounded-2xl bg-white p-5 shadow-sm md:flex-row md:space-y-0">
          <div
            className="md:min-w-1/4 relative w-full md:w-1/4"
            ref={dropdownRef}
          >
            <button
              className="flex w-full items-center rounded-md border bg-white px-4 py-2 text-gray-700 hover:bg-gray-100 focus:outline-none focus:ring-1 focus:ring-[#c51369]"
              onClick={toggleDropdown}
            >
              <HiFilter color="#c51369" className="mr-2 h-5 w-5" />
              {selectedFilter}
            </button>
            {isDropdownOpen && (
              <div className="absolute left-0 z-10 mt-2 w-full min-w-max rounded-md border bg-white shadow-lg md:w-auto">
                <ul className="py-2">
                  {["All Request", "Todays Request", "Last 7 Days Request"].map(
                    (option) => (
                      <li
                        key={option}
                        className="cursor-pointer px-4 py-2 hover:bg-gray-100"
                        onClick={() => handleOptionClick(option)}
                      >
                        {option}
                      </li>
                    )
                  )}
                </ul>
              </div>
            )}
          </div>
        </div>

        <div className="mx-auto py-5">
          {userDataLoading ? (
            <SkeletonLoader />
          ) : (
            <div className="grid gap-5 sm:grid-cols-1 lg:grid-cols-2">
              {accDelReq.length === 0 ? (
                <p className="col-span-2 text-center tracking-wide">
                  No Request Found
                </p>
              ) : (
                accDelReq.map((request, i) => (
                  <div
                    key={i}
                    className="flex flex-row items-center justify-between rounded-2xl bg-white p-6 shadow-sm"
                  >
                    <div className="flex items-center">
                      <img
                        src={request?.user?.selected_Avatar?.avatarUrl}
                        alt="avatar"
                        className="mr-4 h-12 w-12 rounded-full"
                      />
                      <div>
                        <p className="text-lg font-bold tracking-wider text-navy-700">
                          {request?.user?.fullName}
                        </p>
                        <p className="tracking-wide text-gray-700">
                          {request?.reason}
                        </p>
                      </div>
                    </div>
                    {currentTabPermissions?.delete && (
                      <div className="flex gap-4">
                        <button
                          onClick={() => handleOpen(request)}
                          className="rounded-full bg-[#c51369] p-2 text-white hover:bg-[#a10f5b] hover:shadow-lg"
                        >
                          <FaTrashAlt />
                        </button>
                      </div>
                    )}
                  </div>
                ))
              )}
            </div>
          )}
        </div>
      </div>

      <Pagination
        currentPage={currentPage}
        totalPages={totalPages}
        onPageChange={(page) => onPageChange(page, selectedFilter)}
      />
    </>
  );
};

export default DeleteReqList;

const SkeletonLoader = () => (
  <div className="grid gap-5 sm:grid-cols-1 lg:grid-cols-2">
    {Array.from({ length: 6 }).map((_, index) => (
      <div
        key={index}
        className="flex animate-pulse flex-row items-center justify-between rounded-2xl bg-gray-200 p-6 shadow-sm"
      >
        <div className="flex items-center">
          <div className="mr-4 h-12 w-12 rounded-full bg-gray-300"></div>
          <div>
            <div className="mb-2 h-4 w-32 rounded bg-gray-300"></div>
            <div className="h-4 w-24 rounded bg-gray-300"></div>
          </div>
        </div>
        <div className="flex gap-4">
          <div className="h-8 w-8 rounded-full bg-gray-300 p-2"></div>
          <div className="h-8 w-8 rounded-full bg-gray-300 p-2"></div>
        </div>
      </div>
    ))}
  </div>
);
